module.exports = __webpack_public_path__ + "img/10.c038bad4.png";